import React from 'react'
import { Link } from 'react-router-dom'
import DesignSupportLayout from './DesignSupportLayout'

const cards = [
  {
    to: '/design/disease-code',
    title: '질병코드 · 특약 매핑',
    tag: '조회',
  },
  {
    to: '/design/surgery-search',
    title: '수술명 · 종 참고',
    tag: '조회',
  },
  {
    to: '/design/major-disease-n',
    title: 'N대 질병',
    tag: '조회',
  },
  {
    to: '/data/design-support-reference',
    title: '데이터 적재',
    tag: '운영',
  },
]

export default function DesignSupportHubPage() {
  return (
    <DesignSupportLayout>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="group flex flex-col rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition hover:border-brand-sky/40 hover:shadow-md"
          >
            <div className="flex items-center justify-between gap-2">
              <h2 className="text-base font-semibold text-slate-900 group-hover:text-brand-navy">{c.title}</h2>
              <span className="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-600">
                {c.tag}
              </span>
            </div>
            <span className="mt-4 text-sm font-medium text-brand-sky group-hover:underline">열기 →</span>
          </Link>
        ))}
      </div>
    </DesignSupportLayout>
  )
}
